import { apiService } from "../../app.service";

export const setLocalAdminPasswordApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    setLocalAdminPassword: builder.mutation({
      query: (data) => ({
        url: "/user/set-password",
        method: "POST",
        body: {
          email: data.email,
          password: data.password,
          token: data.token,
        },
      }),
    }),
  }),
});

export const {
  useSetLocalAdminPasswordMutation,
} = setLocalAdminPasswordApi;